// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2020":"b00f302d47dc3cd4","2888":"be653198d428a2d1"}[chunkId] + ".css";
};